import onChange from 'on-change';
import React, { useContext } from 'react';
import { useEffect, useState } from 'react';

import { ExperimentsContext } from './experimentsContext';

export const useExperiments = () => {
  return useContext(ExperimentsContext);
};

export const ExperimentsProvider: React.FC = ({ children }) => {
  const [experiments, setExperiments] = useState({ ...window.experiments });

  useEffect(() => {
    onChange.unsubscribe(window.experiments);
    window.experiments = onChange(window.experiments, () => {
      setExperiments({ ...window.experiments });
    });

    return () => {
      onChange.unsubscribe(window.experiments);
    };
  }, []);

  return <ExperimentsContext.Provider value={{ experiments }}>
    {children}
  </ExperimentsContext.Provider>;
};
